import './src/materialkit/assets/scss/material-kit-pro-react.scss'
import React from 'react'
import { FbContext } from './src/components/fbContext'

export const wrapRootElement = ({ element }) => {
  return <FbContext>{element}</FbContext>
}
